<ngx-spinner bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="false">
    <p style="color: white" translate>general.spinner</p>
</ngx-spinner>
